import React from 'react'
import { IHealthProcedures, IHealthProceduresOmics, TimelinePeriodTypes } from '~/interfaces'
import { getTimelineRowPosition, groupEllipsesInARow } from '~/utils/dashboard/timeline'
import { TimelineEllipseGroupButton, TimelineEllipseButton } from '~/components/shared'

export interface TimelineEllipsesProps {
  healthProcedures: IHealthProcedures[]
  period: TimelinePeriodTypes
  handleClick: (healthProcedures: IHealthProcedures[]) => void
}

export const TimelineOmics = ({ healthProcedures, period, handleClick }: TimelineEllipsesProps): JSX.Element => {
  const positionedHealthProcedures = getTimelineRowPosition({
    healthProcedures: healthProcedures as IHealthProceduresOmics[],
    mode: period
  })
  const healthProceduresGroup = groupEllipsesInARow(positionedHealthProcedures)

  return (
    <>
      {healthProceduresGroup.map(healthProcedure => {
        const isIndividual = healthProcedure.omics.length === 1
        const isGrouped = healthProcedure.omics.length > 1
        const isAGroupOfSameType = !healthProcedure.differentTypes

        if ((isAGroupOfSameType && isGrouped) || isIndividual) {
          return (
            <TimelineEllipseButton
              key={healthProcedure.omics[0].id}
              healthProcedures={healthProcedure.omics}
              position={healthProcedure.percentagePosition}
              quantity={isIndividual ? 0 : healthProcedure.omics.length}
              onClick={omics => handleClick(omics)}
            />
          )
        }

        if (isGrouped) {
          return (
            <TimelineEllipseGroupButton
              key={healthProcedure.omics[0].id}
              onClick={omics => handleClick(omics)}
              healthProcedures={healthProcedure.omics}
              position={healthProcedure.percentagePosition}
            />
          )
        }
      })}
    </>
  )
}
